<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between align-items-start pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="d-inline-flex">
        <h1 class="h2">Cooperativas</h1>

        <hr class="vertical-bar" />
      </div>

      <b-form-input
        autofocus
        v-on:keyup.enter="search"
        v-model="viewData.search"
        placeholder="Digite um termo e pressione enter para buscar"
        class="mr-3"
      ></b-form-input>

      <BaseButtonComponent to="/cooperative/new" variant="primary-action"
        >Nova</BaseButtonComponent
      >

      <vue-json-to-csv :json-data="state.listCSV" :separator="';'">
        <BaseButtonComponent block variant="primary-action">
          CSV
        </BaseButtonComponent>
      </vue-json-to-csv>
    </div>

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      class="d-flex justify-content-between flex-column h-100"
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
    >
      <v-table>
        <thead>
          <tr>
            <td>Nome</td>
            <td>CNPJ</td>
            <td>Denominação</td>
            <td>Observações</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ item.name }}</td>
            <td>{{ formatSocialNumber(item.socialNumber) }}</td>
            <td>{{ item.denomination }}</td>
            <td>{{ item.notes }}</td>
            <td style="text-align: right">
              <BaseButtonComponent
                :to="`/cooperative-members/${item.id}`"
                size="sm"
                v-b-tooltip.hover
                title="Membros"
                variant="secondary-action"
              >
                <b-icon icon="people" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                :to="`/cooperative/edit/${item.id}`"
                size="sm"
                v-b-tooltip.hover
                title="Editar"
                variant="primary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </v-table>

      <b-pagination-nav
        class="mt-3"
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import VueJsonToCsv from 'vue-json-to-csv';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'cooperative-index',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
        listCSV: [],
      },
      viewData: {
        loading: true,
        search: '',
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    if (this.$route.query && this.$route.query.search) {
      this.viewData.search = this.$route.query.search;
    }

    await this.getAll();
  },
  methods: {
    formatSocialNumber(socialNumber) {
      if (socialNumber.length === 11) {
        return socialNumber.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/g,
          '$1.$2.$3-$4',
        );
      } else {
        return socialNumber.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
          '$1.$2.$3/$4-$5',
        );
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    search() {
      this.$router.push({
        query: { page: 1, search: this.viewData.search },
      });
    },
    async getAll() {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/cooperatives' + helpers.toQueryString(this.$route.query),
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;

        this.state.listCSV = this.state.list.map(item => ({
          Nome: item.name,
          CNPJ: this.formatSocialNumber(item.socialNumber),
          Denominacao: item.denomination,
          Observacoes: item.notes,
        }));
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir [${item.name}] ?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        await API.post('/execute', {
          path: '/cooperative/' + item.id,
          method: 'delete',
        });

        this.$toast.success('Cooperativa excluída com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
  },
  components: {
    VueJsonToCsv,
    BaseButtonComponent,
  },
};
</script>
